import { render, staticRenderFns } from "./DIadmin.vue?vue&type=template&id=6b4c9257&scoped=true"
import script from "./DIadmin.vue?vue&type=script&lang=js"
export * from "./DIadmin.vue?vue&type=script&lang=js"
import style0 from "./DIadmin.vue?vue&type=style&index=0&id=6b4c9257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c9257",
  null
  
)

export default component.exports